import React, { ChangeEvent, ChangeEventHandler, FC, useState } from "react";
import { Box,  Stack } from "@mui/material";
import { useLazyAutocompleteCityQuery } from "@app/data/location/locationApi";
import useGeoProvider from "@shared/GeoProvider";
import TextField from "@mui/material/TextField";
import { FixedSizeList } from "react-window";
import { CityLocation, CityLocationsArray } from "@app/data/location/schema";
import { rowBuilder } from "@components/header/GeoMenu/RowBuilder";
import { getLargestCitiesOfRussia, ALL_RUSSIA } from "@components/header/GeoMenu/initCityData";
import { useAppDispatch, useAppSelector } from "@app/hooks";
import { updateCityFilter, setShowAll, resetToAllRussia, updateCategoryId } from "@shared/filter/filterSlice";
import { selectCurrentTypeIds } from "@shared/filter/selectors";

export interface GeoMenuProps {
  onClose: ()=>void
}

const GeoMenu:FC<GeoMenuProps> = ({onClose}) => {

  const [searchCity, { data }] = useLazyAutocompleteCityQuery()
  const [IpLocation, setLoc] = useGeoProvider()
  const dispatch = useAppDispatch()
  const [initData] = useState<CityLocationsArray>(getLargestCitiesOfRussia({
    city: IpLocation.city,
    latitude: IpLocation.latitude.toString(),
    longitude: IpLocation.longitude.toString(),
    region: IpLocation.region
  }))
  const [inputValue, setInputValue] = useState<string>("");
  const inputChangeHandler: ChangeEventHandler<HTMLInputElement> = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value)
    if (value && value.length > 1) {
      searchCity({
        partialAddress: value,
        resultAmount: 15
      })
    }
  }
  const currentTypeIds = useAppSelector(selectCurrentTypeIds)

  const selectedCityHandler = (city: CityLocation) => {
    if (city.city === "Вся Россия") {
      setLoc({ city: "Вся Россия", latitude: 0, longitude: 0, region: "Россия", source: "manual" })
      dispatch(resetToAllRussia())
      // Восстанавливаем выбранную категорию — смена города не должна её сбивать
      if (currentTypeIds && (Array.isArray(currentTypeIds) ? currentTypeIds.length > 0 : true)) {
        dispatch(updateCategoryId(currentTypeIds))
        dispatch(setShowAll(false))  // категория выбрана — режим «Все» выключен
      }
    } else {
      setLoc({
        city: city.city, latitude: Number(city.latitude), longitude: Number(city.longitude), region: city.region, source: "manual"
      })
      dispatch(updateCityFilter(city.city))
      // Не трогаем setShowAll и категории — пользователь выбрал фильтр, смена города не должна его сбить
    }
    onClose()
  }
  return <Box>
    <Stack direction="column" spacing={2}>
      <TextField value={inputValue} onChange={inputChangeHandler} fullWidth placeholder="Выберите город" />
      <FixedSizeList<CityLocationsArray | undefined>
        height={300}
        width={"100%"}
        itemSize={52}
        itemCount={data?.length ?? initData.length}
        overscanCount={5}
        itemData={data}
      >
        {rowBuilder(selectedCityHandler, initData )}
      </FixedSizeList>
    </Stack>
  </Box>
}
export default GeoMenu